// Drives a countdown, invoking `onTick` each second.
// onTick signature: (canShow, seconds, minutes, hours, days) where
// seconds/minutes are zero-padded strings and hours/days are numbers.
function runCountdown(config, onTick) {
  const maxLoopResets = 100;
  let endTime;
  let startTime;
  const reset = config.reset;
  const duration = config.duration;

  if (config.deadline && !reset) {
    endTime = Date.parse(config.deadline);
    if (Number.isNaN(endTime)) {
      onTick(false, "00", "00", 0, 0);
      return;
    }
    startTime = Date.now();
  } else if (reset && duration > 0) {
    const anchor = new Date(0, -1, 0, 0, 0);
    startTime = anchor.getTime();
    endTime = startTime + duration;
  } else {
    onTick(false, "00", "00", 0, 0);
    return;
  }

  if (Date.now() < startTime) {
    onTick(false, "00", "00", 0, 0);
    return;
  }

  const startInterval = () => {
    const intervalId = setInterval(() => {
      const now = Date.now();
      let distance = endTime - now;

      if (distance < 0) {
        clearInterval(intervalId);
        if (reset) {
          let attempt = 0;
          while (distance < 0 && attempt < maxLoopResets) {
            attempt++;
            if (attempt === 1) {
              const elapsed = now - startTime;
              const loopOffset = Math.floor(elapsed / duration) - 1;
              startTime = startTime + loopOffset * duration;
            } else {
              startTime = endTime;
            }
            endTime = startTime + duration;
            distance = endTime - now;
          }
          if (attempt >= maxLoopResets) {
            onTick(false, "00", "00", 0, 0);
            return;
          }
          startInterval();
        } else {
          onTick(false, "00", "00", 0, 0);
        }
        return;
      }

      if (distance > 0) {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (distance % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        onTick(
          true,
          String(seconds).padStart(2, "0"),
          String(minutes).padStart(2, "0"),
          hours,
          days
        );
      }
    }, 1000);
  };

  const tick = () => {
    const now = Date.now();
    let distance = endTime - now;

    if (distance < 0 && reset && duration > 0) {
      let attempt = 0;
      while (distance < 0 && attempt < maxLoopResets) {
        attempt++;
        if (attempt === 1) {
          const elapsed = now - startTime;
          const loopOffset = Math.floor(elapsed / duration) - 1;
          startTime = startTime + loopOffset * duration;
        } else {
          startTime = endTime;
        }
        endTime = startTime + duration;
        distance = endTime - now;
      }
    }

    if (distance > 0) {
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      onTick(
        true,
        String(seconds).padStart(2, "0"),
        String(minutes).padStart(2, "0"),
        hours,
        days
      );
    } else if (!reset) {
      onTick(false, "00", "00", 0, 0);
      return;
    }
  };

  tick();
  startInterval();
}

if (!customElements.get("product-countdown-badge")) {
  customElements.define(
    "product-countdown-badge",
    class ProductCountdownBadge extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === "true") return;
        this.dataset.initialized = "true";

        const daysGroupEl = this.querySelector("[data-countdown-days-group]");
        const daysEl = this.querySelector("[data-countdown-days]");
        const hoursEl = this.querySelector("[data-countdown-hours]");
        const minutesEl = this.querySelector("[data-countdown-minutes]");
        const secondsEl = this.querySelector("[data-countdown-seconds]");
        const daysLabelEl = this.querySelector("[data-countdown-days-label]");

        if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

        const config = {
          deadline: this.dataset.deadline || "",
          reset: this.dataset.reset === "true",
          duration: parseInt(this.dataset.duration, 10) || 0,
        };

        runCountdown(config, (canShow, seconds, minutes, hours, days) => {
          if (!canShow) {
            this.hidden = true;
            return;
          }

          this.hidden = false;
          daysEl.textContent = days;
          hoursEl.textContent = String(hours).padStart(2, "0");
          minutesEl.textContent = minutes;
          secondsEl.textContent = seconds;

          if (daysGroupEl) {
            daysGroupEl.hidden = days === 0;
          }

          if (daysLabelEl) {
            daysLabelEl.textContent =
              days === 1
                ? daysLabelEl.dataset.singular || "Day"
                : daysLabelEl.dataset.plural || "Days";
          }
        });
      }
    }
  );
}
